export class MembershipPlanModel {
  public productId: string;
  public id: string;
  public name: string = '';
  public title: string = '';
  public description: string = '';
  public minNumberOfVenues: number;
  public maxNumberOfVenues: number;
  public defaultMonthlyPrice: number;
  public defaultYearlyPrice: number;
  public countryIds: Array<number> = new Array<number>();
  public countryNames: Array<string>;
  public projectId: number;
}
